import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import {
    EmailObject
    , EntityEmailObject
    , RateConfirmationEmail
    , RateConfirmationEmailBatch
} from '../models/models';
import { error } from 'util';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class EmailService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error("Backend returned code ${error.status}, body was: ", error.error);
        }
        // Return an observable with a user-facing error message.
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }

    public sendEmail(to: string, cc: string, bcc: string, groupId: number, subject: string, body: string): Observable<boolean> {
        var email = {
            to: to,
            cc: cc,
            bcc: bcc,
            groupId: groupId,
            fromEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            subject: subject,
            body: body
        } as EmailObject;
        console.log(email);
        return this.http.post<boolean>(this.baseUrl + 'api/Email/SendEmail', email, httpOptions)
            .pipe(
                catchError(err => this.handleError(err))
                //catchError(this.handleError("sendEmail", email))
                //catchError(this.handleError("sendEmail", email))
        );
    }

    public sendEmailAsync(to: string, cc: string, bcc: string, groupId: number, subject: string, body: string): Observable<boolean> {
        var email = {
            to: to,
            cc: cc,
            bcc: bcc,
            groupId: groupId,
            fromEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            subject: subject,
            body: body
        } as EmailObject;
        console.log(email);
        return this.http.post<boolean>(this.baseUrl + 'api/Email/SendEmailAsync', email, httpOptions)
            .pipe(
                catchError(err => this.handleError(err))
                //catchError(this.handleError("sendEmail", email))
                //catchError(this.handleError("sendEmail", email))
            );
    }

    public sendOfferEmail(offerID: number, to: string, cc: string) {
        var email = {
            to: to,
            cc: cc,
            bcc: "",
            groupId: 0,
            fromEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            subject: "",
            body: ""
        } as EmailObject;
        var entityEmailObj: EntityEmailObject = {
            entityID: offerID,
            entityName: "Offer",
            emailObj: email
        }
        //return this.http.get<boolean>(this.baseUrl + 'api/Email/SendOfferEmail/?offerID=' + offerID + '&employeeID=' + employeeID);
        return this.http.post<boolean>(this.baseUrl + 'api/Email/SendOfferEmail/', entityEmailObj, httpOptions);
    }

    public sendAvailableLoadOfferEmail(quoteOrderLineID: number, to: string, cc: string) {
        var email = {
            to: to,
            cc: cc,
            bcc: "",
            groupId: 0,
            fromEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            subject: "",
            body: ""
        } as EmailObject;
        var entityEmailObj: EntityEmailObject = {
            entityID: quoteOrderLineID,
            entityName: "QuoteOrderLine",
            emailObj: email
        }
        return this.http.post<boolean>(this.baseUrl + 'api/Email/SendAvailableLoadOfferEmail/', entityEmailObj, httpOptions);
    }

    public sendOfferEmailToCSR(offerId: number) {
        return this.http.get<boolean>(this.baseUrl + 'api/Email/SendOfferNoticeToCSR/?offerId=' + offerId);
    }

    public sendRateConfirmation(lineId: number) {
        var employeeId = parseInt(localStorage.getItem('EmployeeId')!);
        return this.http.get<boolean>(this.baseUrl + 'api/Email/SendRateConfirmation/?lineId=' + lineId + '&employeeId=' + employeeId);
    }

    public sendRateConfirmationCustom(quoteOrderLineID: number, to: string, cc: string, bcc: string, groupId: number, subject: string, body: string) {
        var email = {
            to: to,
            cc: cc,
            bcc: bcc,
            groupId: groupId,
            fromEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            subject: subject,
            body: body
        } as EmailObject;
        var rateConEmail: RateConfirmationEmail = {
            quoteOrderLineID: quoteOrderLineID,
            emailObj: email
        }
        console.log("sendRateConfirmationCustom", rateConEmail);
        return this.http.post<boolean>(this.baseUrl + 'api/Email/SendRateConfirmationCustom/', rateConEmail, httpOptions);
    }

    public sendRateConfirmationBatch(offerBatchID: number, to: string, cc: string, bcc: string, groupId: number, subject: string, body: string) {
        var email = {
            to: to,
            cc: cc,
            bcc: bcc,
            groupId: groupId,
            fromEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            subject: subject,
            body: body
        } as EmailObject;
        var rateConEmailBatch: RateConfirmationEmailBatch = {
            offerBatchID: offerBatchID,
            emailObj: email
        }
        console.log("sendRateConfirmationBatch", rateConEmailBatch);
        return this.http.post<boolean>(this.baseUrl + 'api/Email/SendRateConfirmationBatch/', rateConEmailBatch, httpOptions);
    }
}